import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect, useCallback } from 'react';
import { Button, Card, Cell } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DropdownMenu = _ref => {
  let {
    actions,
    buttonProps,
    styling,
    separator
  } = _ref;
  const {
    0: isDropdownVisible,
    1: setIsDropdownVisible
  } = useState(false);
  const handleDocumentClick = useCallback(() => {
    setIsDropdownVisible(false);
  }, []);
  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener('click', handleDocumentClick);
    }

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [isDropdownVisible, handleDocumentClick]);

  const handleButtonClick = event => {
    event.stopPropagation();
    setIsDropdownVisible(prevIsDropdownVisible => !prevIsDropdownVisible);
  };

  const renderActions = () => actions.map(action => {
    const {
      id,
      text,
      url,
      prefix,
      onClick
    } = action;
    return /*#__PURE__*/_jsx(Cell, {
      prefix: prefix,
      testId: "".concat(id, "-button"),
      body: text,
      styling: styling || Cell.Styling.Narrow,
      type: Cell.Type.Navigating,
      url: url,
      onClick: onClick
    }, id);
  });

  const renderSeparatedList = () => /*#__PURE__*/_jsx(SeparatedList, {
    separator: separator,
    children: renderActions()
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
      onClick: handleButtonClick
    })), isDropdownVisible && /*#__PURE__*/_jsx("div", {
      className: "dropdown-menu",
      children: /*#__PURE__*/_jsx(Card, {
        styling: Card.Styling.Lifted,
        children: separator ? renderSeparatedList() : renderActions()
      })
    })]
  });
};

export default DropdownMenu;